import script from "./HomeContactItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeContactItem.vue?vue&type=script&setup=true&lang=ts"

import "./HomeContactItem.vue?vue&type=style&index=0&id=692ed03a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-692ed03a"]])

export default __exports__